/**
 * values for setting the 'format' in address fields
 */

const ADDRESS_FORMAT = {
  UK:            'uk',
  US:            'us',
  EU:            'eu',
  INTERNATIONAL: 'gl',
};

const ADDRESS_FORMAT_ALL = _.values(ADDRESS_FORMAT, 'value');

const ADDRESS_FORMAT_ENTRIES = {
  [ADDRESS_FORMAT.UK]:            { text: 'United Kingdom', value: ADDRESS_FORMAT.UK, description: '' },
  [ADDRESS_FORMAT.US]:            { text: 'United States', value: ADDRESS_FORMAT.US, description: '' },
  [ADDRESS_FORMAT.EU]:            { text: 'European', value: ADDRESS_FORMAT.EU, description: '' },
  [ADDRESS_FORMAT.INTERNATIONAL]: { text: 'International', value: ADDRESS_FORMAT.INTERNATIONAL, description: '' },
};

const ADDRESS_FORMAT_LIST = [
  ADDRESS_FORMAT_ENTRIES[ADDRESS_FORMAT.UK],
  ADDRESS_FORMAT_ENTRIES[ADDRESS_FORMAT.US],
  ADDRESS_FORMAT_ENTRIES[ADDRESS_FORMAT.INTERNATIONAL],
];

const EXTENDED_ADDRESS_FORMAT_LIST = [
  ADDRESS_FORMAT_ENTRIES[ADDRESS_FORMAT.UK],
  ADDRESS_FORMAT_ENTRIES[ADDRESS_FORMAT.US],
  ADDRESS_FORMAT_ENTRIES[ADDRESS_FORMAT.EU],
  ADDRESS_FORMAT_ENTRIES[ADDRESS_FORMAT.INTERNATIONAL],
];

export { ADDRESS_FORMAT, ADDRESS_FORMAT_LIST, EXTENDED_ADDRESS_FORMAT_LIST, ADDRESS_FORMAT_ALL };

export default ADDRESS_FORMAT;
